module.exports = __webpack_public_path__ + "img/slideshow-two.e621e3f1.jpg";